<template>
    <div class="modal fade reviewreminderbox" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div style="border-radius: 20px" class="modal-content mx-3 my-auto">
                <div class="container-fluid transit popup-box">
                    <div class="thanks-shr-btn" @click="emit('share')"><img src="@/assets/share-btn.svg"/></div>   
                    <!-- <div class="row d-flex my-3">
                        <div class="col">
                            <div style="width: 50%;" class="logo mx-auto">
                                <img class="img-fluid logo" src="@/assets/dark-tree.svg" alt="myapptree logo" />
                            </div>
                        </div>
                    </div> -->
                    <div class="text-center lottie-container">
                        <lottie-player
                            :src="lottie"  background="transparent"  speed="1"  style="width: 100%; height: 100%;"  loop autoplay >
                        </lottie-player>
                    </div>
                    <h1 class="text-center plus-savedtrees" v-html="'+'+newTrees"></h1>
                    <div class="savemodal-text my-3 mx-2">
                        <span v-html="text"></span>
                    </div>
                    
                    <button type="button" @click="close()"
                        class="btn-sm btn btn-savetheworld w-100 buttonLink my-3 align-bottom d-block p-3">

                        <span data-text="rate" v-html="locale.save_the_world"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

const $ = window.$;
/* eslint-disable no-console*/

export default {
  name: 'Thanks',
  data(){
      return{
        //   trees: 2,
          disabled: 'enabled',
          locale: this.$locale.thanks
      }
  },
  props: ['newTrees', 'modalId', 'text', 'lottie'],
  methods: {
    emit: function(eventname) {
      this.$emit(eventname, this.locale.sharing_text + 'https://play.google.com/store/apps/details?id=com.myappfree.myapptree')
    //   $('#thanksmodal').modal('hide');
    },
    close: function(){
        $('#'+this.modalId).modal('hide');
    },
    share: function(){

    }
  },
    components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    /* .transit{
    -webkit-transition: max-height 1s; 
  -moz-transition: max-height 1s; 
  -ms-transition: max-height 1s; 
  -o-transition: max-height 1s; 
  transition: max-height 1s;
            } */
    .modal-text{
        color: white;
        text-shadow: grey;
    }
    .logo{
        max-width: 15vw;
    }
    .btn-savetheworld {
        border-radius: 15px!important;
        color: #000;
        background-color: #6AB04C;
        color: #34495e!important;
        font-weight: bold!important;
        span {
            font-size: 1.2rem;
            color: white;
        }
    }
    // .btn-savetheworld span {
    //     font-size: 1.2rem;
    //     color: white;
    // }
    .savemodal-text span{
        color: white;
        font-size: 1.2rem;

        margin-bottom: 0.5rem;
        font-weight: 500;
        line-height: 1.2;
    }
    .plus-savedtrees{
        color: white;
        font-family: "Segoe UI"
    }

    .lottie-container{
        margin-top: -4.5rem;
        margin-bottom: -5.5rem;
    }

    .thanks-shr-btn{
        position: absolute;
        right: 0;
        width: 2.5rem;
        margin: 0.45rem;
        z-index: 100;
    }
</style>
